import axios from '@sas/nova-core/axios';

// REST helper functions
export const fetchBody = async axiosConfig => {
  const response = await axios(axiosConfig);
  return response.data;
};
//# sourceMappingURL=service.js.map